import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../../config/api";

const Flujo = () => {

    const { id } = useParams();
    const navigate = useNavigate();
    const { authFetch } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    const formatearMoneda = (valor) => {
    if (valor === null || valor === undefined || valor === "") {
        return "";
    }

    return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }).format(Number(valor));
};

    // INFO CONTRATO
    const [contrato, setContrato] = useState(null);
    const [flujoCaja, setFlujoCaja] = useState([]);

    // FORM

    const [formData, setFormData] = useState({
        id_informacion_general: Number(id),
        fecha_proyectada_facturacion: "",
        valor_proyectado_facturar: ""
    });

    // CARGAR CONTRATO
    useEffect(() => {
        const loadContrato = async () => {

            try {
                const res = await authFetch(`${ENDPOINTS.get_contrato_actual}?id=${id}`);

                if (res.success) {
                    setContrato(res.data);
                }

            } catch (error) {
                console.error(error);
                setError("Error cargando contrato");
            }

        };

        const loadFlujoCaja = async () => {
            try {
                const res = await authFetch(`${ENDPOINTS.get_flujo_caja}?id_informacion_general=${id}`);

                if (res.success) {

                    setFlujoCaja(res.data);

                } else {

                    setFlujoCaja([]);

                }

            } catch (error) {

                console.error(error);
                setFlujoCaja([]);

            }

        };

        const loadData = async () => {
            setLoading(true);
            await loadContrato();
            await loadFlujoCaja();
            setLoading(false);

        };
        loadData();
    }, [id, authFetch]);

    // ==========================
    // INPUTS
    // ==========================

      const handleChange = (e) => {

          const { name, value } = e.target;

          // ==========================
          // VALOR MONETARIO
          // ==========================
          if (name === "valor_proyectado_facturar") {

              const valorLimpio = value.replace(/\D/g, "");

              setFormData((prev) => ({
                  ...prev,
                  valor_proyectado_facturar: valorLimpio
              }));

              return;
          }

          setFormData((prev) => ({
              ...prev,
              [name]: value
          }));
      };
    // ==========================
    // RECARGAR HISTORIAL
    // ==========================

    const loadFlujoCaja = async () => {
        try {

            const res = await authFetch(`${ENDPOINTS.get_flujo_caja}?id_informacion_general=${id}`);

            if (res.success) {
                setFlujoCaja(res.data);
            } else {
                setFlujoCaja([]);
            }

        } catch (error) {
            console.error(error);
            setFlujoCaja([]);
        }

    };

    // ==========================
    // GUARDAR
    // ==========================

    const handleSubmit = async (e) => {

        e.preventDefault();
        setError("");
        setSuccess("");

        if (!formData.fecha_proyectada_facturacion || !formData.valor_proyectado_facturar) {

            setError("Debe diligenciar todos los campos.");
            return;

        }

        try {

            const res = await authFetch(ENDPOINTS.create_flujo_caja,

                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(
                        formData
                    )
                }

            );

            if (!res.success) {

                setError(
                    res.message
                );
                return;

            }

            setSuccess("Flujo de caja registrado correctamente.");
            await loadFlujoCaja();
            setFormData({

                id_informacion_general: Number(id),
                fecha_proyectada_facturacion: "",
                valor_proyectado_facturar: ""
            });

        } catch (error) {

            console.error(error);
            setError("Error del servidor.");

        }

    };

    // ==========================
    // LOADING
    // ==========================

    if (loading) {

        return (

            <p>Cargando...</p>

        );

    }

    return (    
    <div className="p-4">

      <div className="d-flex justify-content-between align-items-center mb-4">

        <h3>Flujo de Caja</h3>

        <button className="btn btn-outline-pink"
          onClick={() =>navigate("/session/mod_administrativa/informacion_general/informacion_general")}>
          <i className="bi bi-arrow-left me-1"></i>
          Volver
        </button>

      </div>

      {/* CONTRATO */}

      {contrato && (

        <div className="card mb-4">
          <div className="card-header">

            Información del Contrato

          </div>

          <div className="card-body">
            <div className="row">
              <div className="col-md-6">

                <strong>Área:</strong>
                <br />

                {contrato.area_name}

              </div>

              <div className="col-md-6">

                <strong>Programa:</strong>

                <br />

                {contrato.program_name}

              </div>

              <div className="col-md-6 mt-3">

                <strong>Contrato:</strong>

                <br />

                {contrato.contrato_convenio}

              </div>

              <div className="col-md-6 mt-3">

                <strong>Contratante:</strong>

                <br />

                {contrato.contratante}

              </div>

              <div className="col-md-6 mt-3">

                <strong>Fecha Inicio:</strong>

                <br />

                {contrato.fecha_inicio}

              </div>

              <div className="col-md-6 mt-3">

                <strong>Fecha Fin:</strong>

                <br />

                {contrato.fecha_fin}

              </div>

              <div className="col-md-6 mt-3">

               <strong>Valor Contrato:</strong>
                <br />

                {
                    contrato.valor_contrato_antes_iva
                        ? formatearMoneda(contrato.valor_contrato_antes_iva)
                        : "-"
                }

              </div>

            </div>

          </div>

        </div>

      )}

      {/* FORMULARIO */}

      <form className="card p-4" onSubmit={handleSubmit}>

        {error && (
          <div className="alert alert-danger">
            {error}
          </div>
        )}

        {success && (
          <div className="alert alert-success">
            {success}
          </div>
        )}

        <div className="row">

          <div className="col-md-6 mb-3">

            <label>Fecha proyectada facturación</label>
            <input
              type="date"
              name="fecha_proyectada_facturacion"
              className="form-control"
              value={formData.fecha_proyectada_facturacion}
              onChange={handleChange}
            />

          </div>

          <div className="col-md-6 mb-3">

            <label>Valor proyectado facturar</label>
            <input
                  type="text"
                  name="valor_proyectado_facturar"
                  className="form-control"
                  value={formatearMoneda(formData.valor_proyectado_facturar)}
                  onChange={handleChange}
                  inputMode="numeric"
                  placeholder="$0"
              />

          </div>

        </div>

        <button type="submit" className="btn btn-outline-pink w-100 mt-3">
          Registrar Flujo de Caja
        </button>

      </form>

      {/* HISTORIAL */}

      <div className="card mt-4">

        <div className="card-header">
          Historial Flujo de Caja
        </div>

        <div className="card-body">

          {flujoCaja.length === 0 ? (

            <div className="alert alert-light">
              No existen desembolsos registrados.
            </div>

          ) : (

            <div className="table-responsive">

              <table className="table table-bordered table-hover">

                <thead>

                  <tr>

                    <th>Desembolso</th>
                    <th>Código</th>
                    <th>Fecha Proyectada</th>
                    <th>Valor Proyectado</th>
                    <th>Fecha Registro</th>

                  </tr>

                </thead>

                <tbody>

                  {flujoCaja.map((item) => (

                    <tr key={item.id}>

                      <td>{item.desembolso}</td>
                      <td>{item.codigo}</td>
                      <td>{item.fecha_proyectada_facturacion} </td>
                      <td>
                          {item.valor_proyectado_facturar
                              ? formatearMoneda(item.valor_proyectado_facturar)
                              : ""
                          }
                      </td>

                      <td>
                        {
                          new Date(item.created_at)
                            .toLocaleString(
                              "es-CO",
                              {
                                day: "numeric",
                                month: "long",
                                year: "numeric",
                                hour: "numeric",
                                minute: "2-digit",
                                hour12: true
                              }
                            )
                        }

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>

    </div>

  );

};

export default Flujo;